import { TYPES } from '../../flattenTree/utils/consts';
import { getObjectByPath } from '../utils';
import { ActionsDispatcher } from 'simple-action-dispatcher';

export const pathToKey = (key = '') => `/${key.toLowerCase()}`;
export const pathToTreeKeys = (path) =>
  (typeof path === 'string' && path && path.split('.').map(pathToKey)) || [];

export const deleteByPathFromObject = (obj, path) => {
  const keys = pathToTreeKeys(path);
  const lastKey = keys.pop();
  const deleteFrom = getObjectByPath(obj, keys);
  if (deleteFrom[lastKey]) {
    delete deleteFrom[lastKey];
  }
};

const deleteFromMembers = (obj, membersIdentifier, key) => {
  if (obj.data[membersIdentifier]) {
    obj.data[membersIdentifier] = obj.data[membersIdentifier].filter(
      (member) => member.urlFormat !== key,
    );
  }
};

const deleteByPathFromArray =
  (deleteFromMembersIdentifier) => (docsTree, path) => {
    const keys = pathToTreeKeys(path);
    const lastKey = keys.pop().slice(1);
    const deleteFrom = getObjectByPath(docsTree, keys);
    if (deleteFrom && deleteFrom.data) {
      deleteFromMembers(deleteFrom, deleteFromMembersIdentifier, lastKey);
    }
  };

export const deletePropertyByPath = (docsTree, path, type) => {
  const dispatcher = new ActionsDispatcher();
  dispatcher.setDefaultAction(deleteByPathFromObject);
  dispatcher
    .register(TYPES.OPERATION, deleteByPathFromArray('operations'))
    .register(TYPES.CLIENT_EVENT, deleteByPathFromArray('clientEvents'))
    .register(TYPES.WEBHOOK, deleteByPathFromArray('events'))
    .register(TYPES.EVENT, deleteByPathFromArray('events'))
    .register(TYPES.MAIN_ENTITY, deleteByPathFromArray('messages'))
    .register(TYPES.PROPERTY, deleteByPathFromArray('properties'))
    .register(TYPES.MD, deleteByPathFromArray('relatedGuides'))
    .dispatch(type, docsTree, path);
};
